import React, { useState } from "react";
import Form from "react-bootstrap/Form";
import Header from "../../components/header/Header";
import PageHeading from "../../components/pageHeading/PageHeading";
import Footer from "../../components/footer/Footer";
import "./MarketingJob.scss";
import { BackIcon, ClockIcon } from "../../components/Icons";
import { Button, Col, Row } from "react-bootstrap";
import { setLoader } from "../../slice/commonSlice";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { createBookingRequest } from "../../services/auth.service";
import { toast } from "react-toastify";
import { toast_error } from "../../config/Constant";
import { selectUser } from "../../slice/authSlice";
import moment from "moment";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";


const MarketingJob = () => {
  const user = useSelector(selectUser);
  const dispatch = useDispatch();
  const location = useLocation();
  const [jobDetail, setJobDetail] = useState("");
  const [startTime, setStartTime] = useState("");
  const [phoneNumber, setPhoneNumber] = useState(user?.phone);
  const [address, setAddress] = useState("");
  const [email, setEmail] = useState(user?.email);
  const [errors, setErrors] = useState({
    phoneNumber: "",
    address: "",
    email: "",
    jobDetail: "",
    date:"",
    startTime:""
  });
  const [selectedDay, setSelectedDay] = useState(null); // Set default to today
  const navigate = useNavigate();

  // const handleDuration = (e) => {
  //     setDuration(e.target.value)
  // }
  const handleDetails = (e) => {
    setJobDetail(e.target.value);
  };

  const validateForm = () => {
    const newErrors = {
      jobDetail:
        jobDetail.trim() === ""
          ? " Job description is required"
          : jobDetail.length < 20
          ? "Job description should be of minimum 20 characters"
          : "",
      address:
        address.trim() === ""
          ? " Address is required"
          : "",
      phoneNumber:
        phoneNumber.trim() === ""
          ? "Phone Number is required"
          : !/^\d{10}$/.test(phoneNumber.trim())
          ? "Invalid phone number"
          : "",
      email:
        email.trim() === ""
          ? "Email is required"
          : !/^\S+@\S+\.\S+$/.test(email.trim())
          ? "Invalid email address"
          : "",
      date:
        !selectedDay
          ? "Date is required"
          : "",
      startTime:
        !startTime
          ? "Time is required"
          : "",
    };
    setErrors(newErrors);

    return !Object.values(newErrors).some((error) => error !== "");
  };

  const handleSubmit = async () => {
    if (!validateForm()) {
      return;
    }

    // Combine date and time into ISO format
    const dateTime = moment(selectedDay)
      .set({
        hour: moment(startTime).hour(),
        minute: moment(startTime).minute(),
        second: 0,
        millisecond: 0,
      })
      .toISOString();

    // Get user name from user object or form
    const userName = user?.firstName && user?.lastName
      ? `${user.firstName} ${user.lastName}`
      : user?.firstName || email?.split("@")[0] || "Guest User";

      let payload = {
        userName: userName,
        userEmail: email,
        userPhone: phoneNumber,
        jobAddress: address,
        description: jobDetail,
        dateTime: dateTime,
        providerId: location.state?.providerId || null,
        serviceId: location.state?.serviceId || null,
        serviceName: location.state?.serviceName || null,
        jobType: location.state?.jobType || null,
        unitPrice: location.state?.unitPrice || null,
        userId: user?.id || null, // Include userId if user is logged in
      };

    await dispatch(setLoader(true));
    try {
      const response = await createBookingRequest(payload);
      await dispatch(setLoader(false));
      if (response?.data?.status) {
        toast.success(response?.data?.message || "Booking request submitted successfully!", toast_error);
        navigate("/");
      } else {
        toast.error(response?.data?.message || "Failed to submit booking request", toast_error);
      }
    } catch (error) {
      await dispatch(setLoader(false));
      console.error("Error creating booking request:", error);
      toast.error(error?.response?.data?.message || "Failed to submit booking request", toast_error);
    }
  };

  const handleTimeChange = (date) => {
    setStartTime(date);
  };

  const checkDisable = () => {
    if (!jobDetail || !email || !phoneNumber || !address || !selectedDay || !startTime) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <>
      <Header />
      <PageHeading title="Job Details" />
      <div className="main-container">
        <div className="container-wrap">
          <div className="availabilty-wrapper">
            <div className="back-wrapper" onClick={() => navigate(-1)}>
              <div className="back-icon">
                <BackIcon />
              </div>
              <div className="back-title">Job Details</div>
            </div>
            <div className="box-wrapper expected-time-wrapper">
              <Row className="g-4">
                <Col md={3}>
                  <div style={{ position: "relative" }}>
                    <div style={{ fontSize: "14px" }}>Select Date</div>
                    <ReactDatePicker
                      className="form-control"
                      selected={selectedDay}
                      onChange={(date) => {
                        setSelectedDay(date);
                        setErrors({ ...errors, date: "" });
                      }}
                      minDate={moment().toDate()}
                      placeholderText="Job Date"
                    />
                    <span style={{ color: "red" }}>{errors.date}</span>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col sm={3}>
                  <div className="input-wrap1" >
                    <div className="icon-wrap1">
                      <ClockIcon />
                    </div>
                    <Form.Group className="mb-1" >
                      <Form.Label>Select time</Form.Label>
                      <ReactDatePicker
                        selected={startTime}
                        onChange={(date) => {
                          handleTimeChange(date);
                          setErrors({ ...errors, startTime: "" });
                        }}
                        showTimeSelect
                        showTimeSelectOnly
                        timeIntervals={60}
                        dateFormat="h:mm aa"
                        timeCaption="Time"
                        className="react-datepicker-border"
                      />
                    <span style={{ color: "red" }}>{errors.startTime}</span>
                    </Form.Group>
                  </div>
                </Col>
              </Row>
              <Row className="g-1 mt-1">
                <Col md={3}>
                  <Form.Label>Your email</Form.Label>
                  <Form.Control
                    onChange={(e) => setEmail(e.target.value)}
                    type="email"
                    placeholder="Email"
                    value={email}
                  />
                  <span style={{ color: "red" }}>{errors.email}</span>
                </Col>
              </Row>
              <Row className="g-1 mt-1">
                <Col md={3}>
                  <Form.Group className="mb-3" controlId="phoneNumber">
                    <Form.Label>Your phone number</Form.Label>
                    <Form.Control
                      type="text"
                      autoComplete="off"
                      name="phone"
                      value={phoneNumber}
                      // onBlur={handleBlur}
                      onChange={(e) => setPhoneNumber(e.target.value)}
                      placeholder="Phone number"
                    />
                    <span style={{ color: "red" }}>{errors.phoneNumber}</span>
                  </Form.Group>
                </Col>
              </Row>
              <Row className="g-4">
                <Col md={7} style={{marginRight: "10px"}}>
                  <Form.Label>Your address</Form.Label>
                  <Form.Control
                    onChange={(e) => setAddress(e.target.value)}
                    rows={3}
                    as="textarea"
                    placeholder="Address"
                  />
                  <span style={{ color: "red" }}>{errors.address}</span>
                </Col>
              </Row>
              <Row className="g-4 mt-1">
                <Col md={7}>
                  <Form.Label>Describe job details</Form.Label>
                  <Form.Control
                    onChange={handleDetails}
                    rows={10}
                    as="textarea"
                    placeholder="Describe job details"
                  />
                  <span style={{ color: "red" }}>{errors.jobDetail}</span>
                </Col>
                <Col xs={12}>
                  <Button
                    variant="primary"
                    disabled={checkDisable()}
                    onClick={() => handleSubmit()}
                  >
                    Submit Request
                  </Button>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default MarketingJob;
